import {
  ApartmentOutlined,
  ContainerOutlined,
  DotChartOutlined,
  FlagOutlined,
  FormOutlined,
  MailOutlined, PhoneOutlined, RobotOutlined, UsergroupAddOutlined, UserOutlined,
} from '@ant-design/icons';
import { AbFeatures } from '@repo/utils';

export interface Section {
  key: string;
  label: string;
  icon?: React.ReactNode;
  type?: string;
  children?: Section[];
  subsections?: string[];
  forAdminOnly?: boolean;
  featureFlag?: AbFeatures;
}

export enum SectionKeys {
  profile = 'profile',
  users_permissions = 'users-permissions',
  manage_users = 'manage-users',
  security = 'security',
  smart_view = 'smart-views',
  accounts = 'accounts',
  leads = 'leads',
  my_profile = 'my-profile',
  password_login = 'password-login',
  email_signature = 'email-signature',
  requests = 'requests',
  permission_templates = 'permission-templates',
  sales_groups = 'sales-groups',
  lead_fields = 'lead-fields',
  lead_settings = 'lead-settings',
  activities_and_scores = 'activities-and-scores',
  core_activities = 'core-activities',
  custom_activities = 'custom-activities',
  lead_stages = 'lead-stages',
  lead_forms = 'lead-forms',
  forms = 'forms',
  content_management = 'content-management',
  email_templates = 'email-templates',
  telephony_numbers = 'telephony-numbers',
  products = 'products',
  deal_statuses = 'deal-statuses',
  deals_settings_group = 'deals-settings-group',
  ai_calling_agents = 'ai-calling-agents',
}

export const settingsData: Section[] = [
  {
    key: SectionKeys.profile,
    label: 'Profile',
    icon: <UserOutlined />,
    children: [
      {
        key: SectionKeys.my_profile,
        label: 'My Profile',
        icon: <UserOutlined />,
        subsections: ['Personal Details'],
      },
    ],
  },
  {
    key: SectionKeys.users_permissions,
    label: 'Users & Permissions',
    icon: <UsergroupAddOutlined />,
    forAdminOnly: true,
    children: [
      {
        key: SectionKeys.manage_users,
        label: 'Manage Users',
        icon: <UserOutlined />,
        forAdminOnly: true,
      },
      {
        key: SectionKeys.permission_templates,
        label: 'Permission Templates',
        icon: <ContainerOutlined />,
        forAdminOnly: true,
      },
      {
        key: SectionKeys.sales_groups,
        label: 'Sales Groups',
        icon: <UsergroupAddOutlined />,
        forAdminOnly: true,
      },
    ],
  },
  {
    key: SectionKeys.leads,
    label: 'Leads',
    icon: <UsergroupAddOutlined />,
    forAdminOnly: true,
    children: [
      {
        key: SectionKeys.lead_settings,
        label: 'LEAD SETTINGS',
        type: 'group',
        forAdminOnly: true,
        children: [
          {
            key: SectionKeys.lead_fields,
            label: 'Lead Fields',
            icon: <UserOutlined />,
            forAdminOnly: true,
          },
          {
            key: SectionKeys.lead_stages,
            label: 'Lead Stages',
            icon: <FlagOutlined />,
            forAdminOnly: true,
          },
          {
            key: SectionKeys.smart_view,
            label: 'Smart Views',
            icon: <ApartmentOutlined />,
          },
        ],
      },
      {
        key: SectionKeys.forms,
        label: 'FORMS',
        type: 'group',
        forAdminOnly: true,
        children: [
          {
            key: SectionKeys.lead_forms,
            label: 'Lead Forms',
            icon: <FormOutlined />,
            forAdminOnly: true,
          },
        ],
      },
      {
        key: SectionKeys.deals_settings_group,
        label: 'DEALS',
        type: 'group',
        children: [
          {
            key: SectionKeys.products,
            label: 'Products',
            icon: <ContainerOutlined />,
          },
          {
            key: SectionKeys.deal_statuses,
            label: 'Deal Statuses',
            icon: <FlagOutlined />,
          },
        ],
      },
      {
        key: SectionKeys.activities_and_scores,
        label: 'ACTIVITIES & SCORES',
        type: 'group',
        forAdminOnly: true,
        children: [
          {
            key: SectionKeys.core_activities,
            label: 'Core Activities & Scores',
            icon: <DotChartOutlined />,
            forAdminOnly: true,
          },
          {
            key: SectionKeys.custom_activities,
            label: 'Custom Activities & Scores',
            icon: <DotChartOutlined />,
            forAdminOnly: true,
          },
        ],
      },
    ],
  },
  {
    key: SectionKeys.content_management,
    label: 'Content Management',
    icon: <ContainerOutlined />,
    children: [
      {
        key: SectionKeys.email_templates,
        label: 'Email Templates',
        icon: <MailOutlined />,
      },
    ],
  },
  {
    key: SectionKeys.telephony_numbers,
    label: 'Telephony Numbers',
    icon: <PhoneOutlined />,
    forAdminOnly: true,
    featureFlag: AbFeatures.TELEPHONY_ENABLED,
  },
  {
    key: SectionKeys.requests,
    label: 'Requests',
    icon: <UsergroupAddOutlined />,
  },
  {
    key: SectionKeys.ai_calling_agents,
    label: 'AI Calling Agents',
    icon: <RobotOutlined />,
    forAdminOnly: true,
  },
];
